// extracted by mini-css-extract-plugin
export default {"text":"title-module__text___61d27d","picture":"title-module__picture___b22f37"};